import { render } from "./AllFolders.vue?vue&type=template&id=4a8c4a72"
import script from "./AllFolders.vue?vue&type=script&lang=js"
export * from "./AllFolders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__